// Çağrı olayı metni (9.4.10).
//
// Sunucu metni kurmaz, yalnızca `{status, seconds}` döner: uygulama 11 dilli ve
// metni sunucuda üretmek hepsini Türkçeye sabitlerdi. Çeviri burada, tek yerde.
//
// Metin **bakan tarafa göre** değişiyor. Aynı kayıt arayan için "cevap verilmedi",
// aranan için "cevapsız çağrı"dır; ikisini tek metne indirmek arayan kişiye
// kendi çağrısını "cevapsız" diye gösterirdi.
// Uygulamanın kendi i18n bağlamının t() imzası (i18next kullanılmıyor).
type TFunc = (key: string, params?: Record<string, string | number>) => string;

// `kind` sunucudan geliyor ('audio' | 'video'); eski çağrılarda veya eski
// sunucu sürümünde gelmeyebilir, o yüzden yokluğu sesli sayılır.
export type CallEvent = { status: string; seconds: number; kind?: string };

/** 134 → "2:14" */
export function callDuration(saniye: number): string {
  const dk = Math.floor(saniye / 60);
  const sn = saniye % 60;
  return `${dk}:${String(sn).padStart(2, '0')}`;
}

/** `mine` = bakan kişi arayan taraf mı. */
export function callLabel(e: CallEvent, mine: boolean, t: TFunc): string {
  switch (e.status) {
    case 'ended': {
      // Bağlanmış çağrı: başlık sesli/görüntülüyü ayırıyor. Eski çağrılarda
      // `kind` yok — o zaman sesli sayılıyor. Diğer sonuçlar (cevapsız, ret,
      // iptal) türü iddia etmiyor, o yüzden onlar olduğu gibi kalıyor.
      const baslik = e.kind === 'video' ? t('call.logAnsweredVideo') : t('call.logAnswered');
      // Süre 0 ise (kabul edilip anında kapanan çağrı) sayı göstermek kafa
      // karıştırır; yalnız başlık kalır.
      return e.seconds > 0 ? `${baslik} · ${callDuration(e.seconds)}` : baslik;
    }
    case 'missed':
      return mine ? t('call.logNoAnswer') : t('call.logMissed');
    case 'declined':
      return mine ? t('call.logDeclined') : t('call.logYouDeclined');
    // Arayan vazgeçti: kendisi için "iptal", karşı taraf için kaçırılmış bir
    // çağrıdır — telefonu çaldı ve yetişemedi.
    case 'cancelled':
      return mine ? t('call.logCancelled') : t('call.logMissed');
    default:
      return t('call.logAnswered');
  }
}

/** Sohbet kartında cevapsız sonucu kırmızıyla ayırmak için tek kaynak. */
export function isMissedCallForViewer(e: CallEvent, mine: boolean): boolean {
  return !mine && (e.status === 'missed' || e.status === 'cancelled');
}
